<template>
    <section class="interest grid" v-if="showPartial">
        <!-- <pre v-if="container" v-text="container"></pre> -->

        <div class="grid--container interest--container">
            <div class="grid--row interest--row">
                <component class="grid--col interest--col"
                        v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                        :is="plugin.type"
                        :plugin="plugin">
                </component>
            </div>
        </div>
    </section>
</template>

<script>
    import cmsPartial from 'vue/mixins/cms/cms-partial';


    export default {
        mixins: [
            cmsPartial,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?2af5800f